import React from "react";

import { Card } from "@jsainsburyplc/id-ui-common";
import { Section } from "@sainsburys-tech/luna-section";
import { Account } from "@sainsburys-tech/luna-icons";

import { withLinks } from "selectors";

import Locked from "images/icons/locked.js";

const FindOutMoreNectar = () => {
  const { privacyPolicy, helpCentre } = withLinks();

  return (
    <>
      <div className="c-hero">
        <h1 className="ln-u-h2">About My ID</h1>
      </div>
      <Card>
        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">What is My ID?</h2>
          <p>SmartShop now uses My ID to make accessing your account easier.</p>
          <p>
            If you have a Sainbury’s Groceries Online or Nectar account, My ID
            means you can now log in to Nectar using the same email and password
            you use to access SmartShop.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">How will this affect me?</h2>
          <h3 className="ln-u-h6">
            Already have a Sainsbury’s Groceries or Nectar account?
          </h3>
          <p>
            You can login to SmartShop using these details. If you have not used
            SmartShop before then you will be asked to add your Nectar card
            before starting. This will now create your My ID account.
          </p>

          <h3 className="ln-u-h6">Already have a SmartShop account?</h3>
          <p>
            If you’re an exisiting SmartShop user you can continue to use your
            account as normal, My ID will not yet be introduced for your
            account.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">What are the benefits of My ID?</h2>
          <ul style={{ marginLeft: "0", marginBottom: "0" }}>
            <li className="ln-u-display-flex">
              <span className="ln-u-h6">
                <Account
                  title="Quick and easy login"
                  style={{ color: "#737373" }}
                />
              </span>
              <span className="ln-u-margin-left*2">
                <h3 className="ln-u-h6 ln-u-margin-bottom">
                  Quick and easy login
                </h3>
                <p>
                  We’re introducing a simple email login, plus you can also use
                  your SmartShop login details to quickly register for
                  Sainsbury’s Groceries or Nectar if you don’t already have an
                  account.
                </p>
              </span>
            </li>

            <li className="ln-u-display-flex">
              <span className="ln-u-h6">
                <Locked title="Security you can trust" />
              </span>
              <span className="ln-u-margin-left*2">
                <h3 className="ln-u-h6 ln-u-margin-bottom">
                  Security you can trust
                </h3>
                <p>
                  We’ll be rolling out our industry-leading technology, so you
                  can be sure your information will always be safe.
                </p>
              </span>
            </li>
          </ul>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Is my personal data safe?</h2>
          <p>
            Yes, in line with data protection regulations, we’re committed to
            not misusing your personal data. Our{" "}
            <a
              className="ln-c-link findOutMore-privacyLink"
              href={privacyPolicy}
            >
              Privacy and Data policy
            </a>{" "}
            is strict - and we like it that way.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Why are we doing this?</h2>
          <p>
            We want to make accessing and managing your account as easy as
            possible. With My ID, you’ll be able to:
          </p>
          <ul style={{ listStyle: "initial", marginBottom: "0" }}>
            <li>
              <p>
                Update your personal details in SmartShop and those details
                automatically update in your Sainsbury’s Groceries or Nectar
                account if you have one
              </p>
            </li>
          </ul>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Does My ID affect my Nectar card?</h2>
          <p>
            No, My ID doesn’t affect your Nectar card. There are no changes in
            how you collect and redeem your points, and there’s no need to get a
            new Nectar card.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">
            I use the same email address on SmartShop, but different Nectar card
            numbers. Will my points be synced?
          </h2>
          <p>
            No, Nectar cards will not be synced, only login details are shared.
            So the Nectar card linked to your Nectar app and website will remain
            separate from the one you use for SmartShop.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Do I have to do anything now?</h2>
          <p>Nothing at all, we’ve already set up everything for you.</p>
        </Section>

        <Section className="ln-u-padding-bottom">
          <h2 className="ln-u-h5">Still have questions about My ID?</h2>
          <p>
            You can visit the{" "}
            <a
              className="ln-c-link findOutMore-helpLink"
              href={`${helpCentre}#myidqueries`}
            >
              Sainsbury’s help centre
            </a>{" "}
            for more information on the My ID service.
          </p>
        </Section>
      </Card>
    </>
  );
};

export default FindOutMoreNectar;
